// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b5ecd877","371":"7fe5971f","389":"6f94b52a","455":"5db31685","857":"06ed2eef","977":"ce07ef40"}[chunkId] + ".chunk.js";
};